import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { SMSApprovePayFor } from './SMSApprovePayFor';
import { OrderDetailPayFor } from './OrderDetailPayFor';
import { CreditCardPayFor } from './CreditCardPayFor';
import {
    getExpensesByMemberNo,
    selectMemberExpenseByMemberNo
} from "../../../state/ducks/member/index";
import { createPaymentPayFor, selectPayment, selectCurrentPage, changeCurrentPage, getActiveMemberNumber, getPaymentSum, selectPaymentSum, getActiveMemberNoList } from "../../../state/ducks/payment/index"
import $ from 'jquery';
import Modal from '../Modal';
import { createPaymentPages } from '../../../state/ducks/payment/types';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
// import { htmlToJsx } from "html-to-jsx-transform";

const pageStatus = [createPaymentPages.orderDetail, createPaymentPages.creditCard, createPaymentPages.sms];

export class CreatePaymentOrderPayFor extends Component {

    state = {
        page: createPaymentPages.orderDetail,
        payment: {
            orderdetail: {
                memberNo: "0",
                startDate: new Date(),
                aylikTutar: "",
                aylikTutarOndalik: 0,
                installmentCount: ""
            },
            creditcard: {
                cardHolderName: "",
                cardNumber: "",
                expirationMonth: new Date().getMonth() + 1,
                expirationYear: new Date().getFullYear(),
                cvv: ""
            },
            sms: {
                sms: "",
                gsm: ""
            },
        }
    };
    componentDidMount() {
        this.props.changeCurrentPage(createPaymentPages.orderDetail)
        this.props.getMemberNumber();
        this.props.getActiveMemberNo();
        $("#aciklama").modal('show');

        if (this.state.page == "sms") {
            //     // window.addEventListener('load', function () {
            //     if (document.getElementsByName('submitBtn') != null)
            //         document.getElementsByName('submitBtn').click();
            //     // }); 

            // document.getElementById('submitBtn').addEventListener('click', this.clickHandler);
        }
    }

    componentWillReceiveProps(nextProps) {
        var pageName = nextProps.payment.page;
        if (pageName != null && pageName != "") {
            this.setState({ page: pageName });
        }
    }
    changePage = (pageName, clearSmsCode) => {
        var currPage = this.state.page;
        // var currPageIndex = pageStatus.findIndex((e) => e === currPage);
        // var pageIndex = pageStatus.findIndex((e) => e === pageName);
        // if (currPage == "sms" && pageIndex < currPageIndex) {
        //     if (window.confirm("Devam etmeniz halinde işlem iptal edilecektir ve bilgileri yeniden girmeniz gerekecektir.")) {
        //         this.props.changeCurrentPage(pageName);
        //     }
        //     return;
        // }

        if (pageName == "sms") {
            this.createPaymentPayFor(currPage, pageName);
        }
        else {
            this.props.changeCurrentPage(pageName);
        }

    }
    getExpensesByMemberNo = (memberNo) => {

        this.props.getMemberExpense(memberNo);
    }
    getPaymentSum = (memberNo) => {
        this.props.getPaymentSummary(memberNo)
    }
    createPaymentPayFor = (currPage, pageName) => {
        var data = this.state.payment;
        if (data.orderdetail.startDate instanceof Date) {
            data.orderdetail.startDate = data.orderdetail.startDate.toLocaleDateString("tr-TR");
        }
        // if (clearSmsCode) {
        //     data.sms = {
        //         sms: "",
        //         gsm: ""
        //     };
        // }
        this.props.createPaymentOrder(data, currPage, pageName);
    }
    // sendSmsAgain = () => {
    //     this.createPaymentPayFor(createPaymentPages.sms, createPaymentPages.sms, true);
    // }



    render() {
        const options = {
            decodeEntities: true,
        };

        var page = this.state.page;
        debugger;
        const { alert, payment } = this.props;
        if (page == "sms") {

            return (
                <div className="container-fluid">
                    <div className="row" style={{ padding: "3%" }}>
                        <div className="col-12">
                            <div>{
                                // htmlToJsx(payment.response.messages[0])
                                // ReactHtmlParser(payment.response.messages[0], options)
                                // <div dangerouslySetInnerHTML={{ __html: payment.response.messages[0] }} />
                            }</div>
                            <iframe width="100%"
                                height="640px" frameBorder="0" src={"data:text/html," + encodeURIComponent(payment.response.messages[0])} />
                        </div>
                    </div>
                </div>

            )
        }
        else {
            return (
                <div className="contanier-fluid">
                    <Modal message={alert?.message} type={alert?.type} />

                    {page == createPaymentPages.orderDetail ? (
                        <OrderDetailPayFor

                            changePage={this.changePage}
                            orderdetail={this.state.payment.orderdetail}
                            getExpense={this.getExpensesByMemberNo}
                            expenses={this.props.expenses}
                            getPaymentSummmary={this.getPaymentSum}
                            payment={this.props.payment}>
                        </OrderDetailPayFor>)
                        : page == createPaymentPages.creditCard ? (
                            <CreditCardPayFor
                                changePage={this.changePage}
                                creditcard={this.state.payment.creditcard}>
                            </CreditCardPayFor>)
                            // : page == createPaymentPages.sms ? (
                            //     <SMSApprovePayFor

                            //         changePage={this.changePage}
                            //         sms={this.state.payment.sms}
                            //         sendAgain={() => this.sendSmsAgain()}>
                            //     </SMSApprovePayFor>)
                            : (<div></div>)
                    }


                    <div className="modal" id="aciklama" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
                        <div className="t-modalAreaMailOrder" id="id-modal" style={{ display: "block" }}>
                            {/* Bu kısım animasyon için Hareket eden kısım. */}
                            <div className="t-modalContentMailOrder" id="id-modalTipi" style={(window.innerWidth <= 900) ? { width: "89%" } : { width: "51%" }}>
                                <div
                                    className="t-modalMailOrder"
                                    id="id-modalGenel"
                                    style={{ backgroundColor: "rgb(255, 255, 255)", boxShadow: "3px 3px 3px #939191" }}
                                >
                                    <div className="container-fluid">
                                        {/* Header */}
                                        <div className="row t-modalHeaderMailOrder">
                                            <div
                                                className="col"
                                                id="id-modalHeader"
                                                style={{ color: "rgb(119, 119, 119)" }}
                                            >
                                                TALİMAT GÖNDERİMİ İLE İLGİLİ AÇIKLAMA
                                            </div>
                                            <div className="col-auto t-cursorPointer" data-dismiss="modal">
                                                <i
                                                    className="t-icon-cross"
                                                    id="id-modalHeaderIcon"
                                                    style={{ color: "rgb(119, 119, 119)" }}
                                                />
                                            </div>
                                        </div>
                                        {/* Body */}
                                        <div className="row t-modalBodyMailOrder">
                                            <div
                                                className="col-12 "
                                                id="id-modalBody"
                                                style={{ color: "rgb(119, 119, 119)", fontSize: "12pt" }}
                                            >
                                                <strong>
                                                    Kredi kartıyla talimatlar yalnızca “organizasyon ve peşinat ücreti” tutarı toplamı kadar girilebilir.
                                                </strong>
                                                <br />
                                                <strong>
                                                    Girdiğiniz ödeme talimatının gerçekleşebilmesi için;
                                                </strong>
                                                <br />
                                                talimat tarihinde, kaydı girilmiş olan kredi kartında yeterli limit
                                                olması durumunda başarılı gerçekleşecektir.

                                                <br />
                                                Tahsilatın başarılı gerçekleşmesi sonrası taksitlere yansıması 1-2
                                                iş günü sürebilmektedir.
                                            </div>
                                        </div>
                                        {/* footer*/}
                                        <div className="row t-modalFooterMailOrder">
                                            <div
                                                className="col-12"
                                                id="id-modalFooter"
                                                style={{ color: "rgb(102, 102, 102)" }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    return {
        payment: selectPayment(state),
        expenses: selectMemberExpenseByMemberNo(state),
        paymentSumData: selectPaymentSum(state)
    };
}
const mapDispatchToProps = dispatch => ({
    createPaymentOrder: (orderdetail, creditCard) => dispatch(createPaymentPayFor(orderdetail, creditCard)),
    getMemberNumber: () => dispatch(getActiveMemberNumber()),
    getActiveMemberNo: () => dispatch(getActiveMemberNoList()),
    changeCurrentPage: (page) => dispatch(changeCurrentPage(page)),
    getMemberExpense: (memberNo) => dispatch(getExpensesByMemberNo(memberNo)),
    getPaymentSummary: (memberNo) => dispatch(getPaymentSum(memberNo))
});
export default connect(mapStateToProps, mapDispatchToProps)(CreatePaymentOrderPayFor);